export default __webpack_public_path__ + "static/media/firefox.db80d9a9.png";